import React, { Component } from "react";
import StepOne from "./steps/StepOne";
import StepTwo from "./steps/StepTwo";
import StepThree from "./steps/StepThree";
import StepFour from "./steps/StepFour";
import "../../style/multiStep.scss";
import assign from "object-assign";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import { createHashHistory } from "history";
import * as qs from "query-string";
import {
  AnimatedView,
  Panel,
  ProgressBar as ProgressBarComponent
} from "../../components";
import { Notification } from "../../components/notifications";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import isEmpty from "lodash.isempty";

let fieldValues = {
  siteID: null,
  siteName: null,
  siteDomain: null,
  siteLogo: null,
  filename: null,
  siteStatus: null,
  id: null,
  userName: null,
  email: null,
  firstName: null,
  lastName: null,
  dob: null,
  gender: null,
  phone: null,
  address1: null,
  address2: null,
  country: null,
  countryName: null,
  stateAbbr: null,
  state: null,
  city: null,
  cityID: null,
  zipcode: null,
  password: null,
  userStatus: null,
  locCountry: null,
  locCountryName: null,
  locStateName: null,
  locState: null,
  locCity: null,
  loccityID: null,
  locAddress1: null,
  locAddress2: null,
  locLatitude: null,
  locPhone: null,
  //isLocationBasic: null,
  siteDealMethod: null,
  commissionPercent:null,
  monthlyFee:null,
  application_fee:null,
  checked:null,
};
let siteDetails = {};
let siteIdParams = "";
const history = createHashHistory();
class ManageSite extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    step: 1,
    siteDataById: {},
    siteId: "",
    alertMessage: "",
    citygeolocation: {},
    disabled: "",
    path: ["Home", "Site List","Add New Site"],
    links: ["home","viewSiteList","manageSite"]
  };

  componentWillMount() {
    siteIdParams = this.props.match.params.siteid
      ? this.props.match.params.siteid
      : "";

    if (siteIdParams) {
      const {
        actions: { getSiteDetailsBySiteId }
      } = this.props;
      getSiteDetailsBySiteId(siteIdParams);
      const editLink = `manageSite/${siteIdParams}`
      this.state.path = ["Home", "Site List","Edit Site"],
      this.state.links = ["home","viewSiteList",editLink]
    }

    if (localStorage.getItem("addNewSiteSavedState")) {
      localStorage.removeItem("addNewSiteSavedState");
    }
    if (localStorage.getItem("cityCountrySateSavedState")) {
      localStorage.removeItem("cityCountrySateSavedState");
    }
    if (localStorage.getItem("fileBase64")) {
      localStorage.removeItem("fileBase64");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({ alertMessage: nextProps.error, msgType: "error", msgStatus: "danger" });
      this.setState({ disabled: false });
      window.scrollTo(0, 0);
    }
    if (this.props.siteDataById !== nextProps.siteDataById && !isEmpty(nextProps.siteDataById)) {
      this.setState({ siteDataById: nextProps.siteDataById });
    }
    if (this.props.citygeolocation !== nextProps.citygeolocation && !isEmpty(nextProps.citygeolocation)) {
      this.setState({ citygeolocation: nextProps.citygeolocation });
    }
  }

  componentWillUnmount() {
    if (localStorage.getItem("addNewSiteSavedState")) {
      localStorage.removeItem("addNewSiteSavedState");
    }
    if (localStorage.getItem("cityCountrySateSavedState")) {
      localStorage.removeItem("cityCountrySateSavedState");
    }
    if (localStorage.getItem("fileBase64")) {
      localStorage.removeItem("fileBase64");
    }
  }

  saveValues(field_value) {
    return function() {
      fieldValues = assign({}, fieldValues, field_value);
    }.bind(this)();
  }

  nextStep() {
    this.setState({
      step: this.state.step + 1
    });
  }

  previousStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  userNameOnChange = val => {
    if (val) {
      let error = {};
      const {
        actions: { checkUserNameData }
      } = this.props;
      checkUserNameData(val);
    }
  };

  siteNameOnChange = val => {
    if (val) {
      let error = {};
      const {
        actions: { checkSiteNameData }
      } = this.props;
      checkSiteNameData(val);
    }
  };
  siteDomainOnChange = val => {
    if (val) {
      let error = {};
      const {
        actions: { checkSiteDomainData }
      } = this.props;
      checkSiteDomainData(val);
    }
  };

  emailOnChange = val => {
    if (val) {
      let error = {};
      const {
        actions: { checkUserEmail }
      } = this.props;
      checkUserEmail(val);
    }
  };

  getCityGeolocation = val => {
    if (val) {
      let error = {};
      const {
        actions: { get_city_geoLocation }
      } = this.props;
      get_city_geoLocation(val);
    }
  };

  submit() {
    // Handle via ajax submitting the user data, upon
    // success return this.nextStop(). If it fails,
    // show the user the error but don't advance
    if (fieldValues) {
      this.setState({ disabled: true });
      if (siteIdParams !== "") {
        try {
          const {
            actions: { update_site_details }
          } = this.props;
          update_site_details(fieldValues);
        } catch (error) {
          alert("error:", error);
        }
      } else {
        try {
          const {
            actions: { add_site_details }
          } = this.props;
          add_site_details(fieldValues);
        } catch (error) {
          alert("error:", error);
        }
      }
    }
  }

  showStep() {
    siteIdParams = this.props.match.params.siteid
      ? this.props.match.params.siteid
      : "";

    let siteDetailData = {};
    let emailResponse,
      messageResponse = {},
      sitenameResponse = {};

    if (siteIdParams && this.props.siteDataById) {
      siteDetailData = this.props.siteDataById;
    } else {
      siteDetailData = {};
    }
    if (this.props.emailResponse) {
      emailResponse = this.props.emailResponse;
    } else {
      emailResponse = {};
    }
    if (this.props.messageResponse) {
      messageResponse = this.props.messageResponse;
    } else {
      messageResponse = {};
    }
    if (this.props.sitenameResponse) {
      sitenameResponse = this.props.sitenameResponse;
    } else {
      sitenameResponse = {};
    }

    switch (this.state.step) {
      case 1:
        return (
          <StepOne
            fieldValues={fieldValues}
            nextStep={this.nextStep.bind(this)}
            previousStep={this.previousStep.bind(this)}
            saveValues={this.saveValues.bind(this)}
            siteNameOnChange={this.siteNameOnChange}
            siteDomainOnChange={this.siteDomainOnChange}
            siteDetails={
              !isEmpty(this.state.siteDataById) && this.state.siteDataById
            }
            sitenameResponse={
              this.props.sitenameResponse && this.props.sitenameResponse
            }
            sitedomainResponse={
              this.props.sitedomainResponse && this.props.sitedomainResponse
            }
          />
        );
      case 2:
        return (
          <StepTwo
            fieldValues={fieldValues}
            nextStep={this.nextStep.bind(this)}
            previousStep={this.previousStep.bind(this)}
            saveValues={this.saveValues.bind(this)}
            userNameOnChange={this.userNameOnChange}
            emailOnChange={this.emailOnChange}
            sitenameResponse={this.props.sitenameResponse}
            emailResponse={this.props.emailResponse}
            siteDetails={
              !isEmpty(this.state.siteDataById) && this.state.siteDataById
            }
          />
        );
      case 3:
        return (
          <StepThree
            fieldValues={fieldValues}
            previousStep={this.previousStep.bind(this)}
            nextStep={this.nextStep.bind(this)}
            saveValues={this.saveValues.bind(this)}
            siteDetails={
              !isEmpty(this.state.siteDataById) && this.state.siteDataById
            }
            getCityGeolocation={this.getCityGeolocation.bind(this)}
            citygeolocation={
              !isEmpty(this.state.citygeolocation) && this.state.citygeolocation
            }
          />
        );
      case 4:
        return (
          <StepFour
            fieldValues={fieldValues}
            previousStep={this.previousStep.bind(this)}
            saveValues={this.saveValues.bind(this)}
            submit={this.submit.bind(this)}
            disabled={this.state.disabled}
          />
        );
    }
  }

  handleDismiss = (e) => {
    this.setState({msgStatus: '', alertMessage: '', msgType: ''});
  }

  render() {
  
    let style = { width: this.state.step / 4 * 100 + "%" };
    return (
      <div className="col-lg-12">
        <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
        <div className="row">
            {this.state.alertMessage !== "" && 
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgStatus}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
            }
        </div>
        <span className="progress-step">Step {this.state.step}</span>
        <progress className="progress" style={style} />
        {this.showStep()}
      </div>
    );
  }
}
export default ManageSite;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/ManageSite.js